import React from 'react';

interface LinkIconProps {
  size?: number;
  color?: string;
}

/**
 * LinkIcon Component
 * @description An external link icon indicating clickable URLs
 */
export const LinkIcon: React.FC<LinkIconProps> = ({ 
  size = 16, 
  color = '#d9d9dc' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 16 16"
    >
      <path 
        fill={color} 
        fillRule="evenodd" 
        d="M14.417 1.583H9.743l-.584.585 1.82 1.82-4.674 4.674 1.033 1.033 4.674-4.674 1.82 1.82.585-.584zm-13 1.607h5.697v1.46H2.878v8.473h8.472V8.887h1.46v5.696H1.417z" 
        clipRule="evenodd"
      />
    </svg>
  );
};

export default LinkIcon;

